export const body = {
    paddingTop: "30px",
    textAlign: "center"
};
